import {Routes,Route} from 'react-router-dom';
import About from "./routes/About";
import Projects from "./routes/Projects";
import Contact from "./routes/Contact";
import Skills from "./routes/Skills";
function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<About/>}/>
        <Route path="/project" element={<Projects/>}/>
        <Route path="/contact" element={<Contact/>}/>
        <Route path="/skills" element={<Skills/>}/>
      </Routes>
    </div>
  );
}

export default App;
